import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const SingleDot = createIcon({
  displayName: 'SingleDot',
  viewBox: '0 0 8 8',
  path: [<circle cx="4" cy="4" fill="#0C6FE2" key="dot" r="4" />],
})
